
// React
import React, { useState, useEffect } from 'react';

// Material UI
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography
  } from '@material-ui/core';

import { DataGrid } from '@material-ui/data-grid';

import { makeStyles } from '@material-ui/core/styles';

import { trackPromise } from 'react-promise-tracker';

import styles from './VersionControlDialgue.module.scss';
  
// Shared
import eventBus from '../../../shared/eventBus';

import { getVersionColumns, getVersionRows } from '../../../versionListingData/versionListingData';

import {
  dialog as dialogStyles,
  dialogTitle as dialogTitleStyles,
  dialogContent as dialogContentStyles,
  dialogActions as dialogActionsStyles
} from '../../../shared/theme';


// Services
import {
  getVersionData as getDataTypeVersionData,
} from '../../../services/data-types';

// Services
import {
  getVersionData as getTaxonomyVersionData,
} from '../../../services/taxonomies';

//import {  } from '../../';

// Hooks
import useMounted from '../../../hooks/useMounted';

// Custom styles
const useDialogStyles = makeStyles(dialogStyles);
const useDialogTitleStyles = makeStyles(dialogTitleStyles);
const useDialogContentStyles = makeStyles(dialogContentStyles);
const useDialogActionsStyles = makeStyles(dialogActionsStyles);

export default function VersionControlDialgue({
    inputProps,
  }) {

    // If the component is mounted
    const mounted = useMounted();

    // State that manage the modal opened/closed
    const [open, setOpen] = useState(false);
    
    const [versionItems, setVerionItems] = useState([]);

    const [columns, setColumns] = useState([]);

    // Disabled state
    const [isDisabled, setDisabled] = useState(false);

    // open the modal window
    const handleOpen = () => {
      setOpen(true);
    };

    // open the modal window
    const handleClose = () => {
      setOpen(false);
    };

    useEffect(() => {

      // the modal button will be disabled if 
      // 1. this is a new item, so no version history
      const isNewItem = inputProps.majorVersion === 0;
      // 2. the current version is 1.0 (there are no other versions)
      const isFirstVersion = inputProps.majorVersion === 1 && inputProps.minorVersion === 0;
      // 3. the endpoint to get the versions is not set
      const hasEndPoint = inputProps.endPoint !== null && inputProps.endPoint !== '' && typeof inputProps.endPoint !== 'undefined';

      if(isNewItem || isFirstVersion || !hasEndPoint) {
        setDisabled(true);
      } else {
        setDisabled(false);
      
        if(open) {

          let promise = null;
          const props = {
            "itemId" : inputProps.itemId,
            "endpoint" : inputProps.endPoint,
            "versionType": inputProps.versionType,
            "getRows" : getVersionRows
          };
          
          if (inputProps.itemType === 'taxonomy') {
            promise = getTaxonomyVersionData(props);
          } else {
            promise = getDataTypeVersionData(props);
          }


          trackPromise(
            promise.then((newData) => {
              if (mounted.current && newData) {
                setVerionItems(newData);
                setColumns(getVersionColumns(newData));
              }
            })
          );

          eventBus.on('dataVersionRestored', (_data) => {

            handleClose();

            eventBus.dispatch('showDetailFormMessage', {
              'messageState' : {
                open: true,
                state: 'info',
                messageText: 'The data version has been restored.  Click save to apply this data version to the current item.',
                messageActions: [{ label: 'Ok', dismiss: true, style: 'default' }],
                autoHideDuration: 5000,
                
              }
            })

          });
          
          eventBus.on('priceVersionRestored', (_data) => {

            handleClose();

            eventBus.dispatch('showDetailFormMessage', {
              'messageState' : {
                open: true,
                state: 'info',
                messageText: 'The price version has been restored.  Click save to apply this price version to the current item.',
                messageActions: [{ label: 'Ok', dismiss: true, style: 'default' }],
                autoHideDuration: 5000,
                
              }
            })

          });

        } else {
          setVerionItems([]);
          setColumns([]);
        }

      }


    }, [open, mounted, inputProps])

    // Custom styles
    const dialogClasses = useDialogStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const dialogActionsClasses = useDialogActionsStyles();

    return(
      <>
        <Grid 
          container 
          alignItems='center' 
          spacing={1}>
          <Grid 
            item 
            xs="auto" 
            className={styles['version-cta-text']}>
              {inputProps.versionLabel} <span className={styles['version-cta-text-number']}>{inputProps.majorVersion}.{inputProps.minorVersion}</span>
          </Grid>
          <Grid
            item 
            xs="auto" >
            <Button
              color="primary"
              className={styles["version-cta-button"]}
              onClick={handleOpen}
              disabled={isDisabled}
              id={`edit-version-${inputProps.versionType}`}>
              {inputProps.ctaLabel}
            </Button>
          </Grid>
          
        </Grid>
        <Dialog
          classes={dialogClasses}
          open={open}
          onClose={handleClose}
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title" classes={dialogTitleClasses}>
              <Typography variant="h2" component="div">
                {inputProps.dialogueTitle}
              </Typography>
            </DialogTitle>
            <DialogContent classes={dialogContentClasses}>
              {
                open && 
                <DataGrid
                  className={styles["version-data-table"]}
                  columns={columns}
                  rows={versionItems}
                  autoHeight={true}
                  rowHeight={40}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  disableSelectionOnClick={true}
                  disableColumnMenu={true}
                  headerHeight={0}
                />
              }
              
            </DialogContent>
            <DialogActions classes={dialogActionsClasses}>
              <Button
                onClick={handleClose}
                disableElevation={true}
                color="secondary"
                variant="outlined"
                size="large">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
      </>
    )
  }